import { render, staticRenderFns } from "./GAuthentication.vue?vue&type=template&id=03ddb71d&"
import script from "./GAuthentication.vue?vue&type=script&lang=ts&"
export * from "./GAuthentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports